module.exports = __webpack_public_path__ + "media/assets/img/flags/nl-NL-0a039b569c1cfc4224f9833283a1ac00.png";